import { AchievementCelebration } from "./achievementCelebration";

export type MilestoneEvent = {
    achievement: AchievementCelebration;
    continueTo: string;
};

type Listener = (event: MilestoneEvent) => void;
const listeners = new Set<Listener>();

// Page-level completions (such as a lesson or grammar point) publish here;
// the header owns the one global modal queue and focus trap.
export function publishMilestone(event: MilestoneEvent): void {
    listeners.forEach((listener) => listener(event));
}

export function subscribeMilestones(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
